import React from "react";
import styled from "styled-components";
import { resolveIconSize } from "@xsolla/xui-primitives-core";
import type { BaseIconInternalProps } from "./types";

const StyledIcon = styled.div<{ $size: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};
  color: ${(props) => props.$color};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const BaseIcon: React.FC<BaseIconInternalProps> = ({
  variant = "line",
  size = 24,
  color = "currentColor",
  solidContent,
  lineContent,
  className,
  style,
  "data-testid": testId,
  testID,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
}) => {
  const svgContent = variant === "line" ? lineContent : solidContent;
  const sizeValue = resolveIconSize(size);

  return (
    <StyledIcon
      $size={sizeValue}
      $color={color}
      className={className}
      style={style}
      data-testid={testId || testID}
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};
